import { useQuery } from '@tanstack/react-query'

import { fetchVenueReservationSetting } from '@/lib/venue/reservationSettingApi'
import type { VenueReservationSettingView } from '@/lib/venue/reservationSettingTypes'

/** 전환 뮤테이션이 같은 키로 캐시를 직접 갱신한다(`useUpdateVenueReservationSetting`). */
export function venueReservationSettingQueryKey(venueId: string) {
  return ['venue', venueId, 'reservation-setting'] as const
}

/** `GET .../reservation-setting` (#758). 게이팅 없음 — 항상 200. */
export function useVenueReservationSetting(venueId: string) {
  return useQuery<VenueReservationSettingView>({
    queryKey: venueReservationSettingQueryKey(venueId),
    queryFn: () => fetchVenueReservationSetting(venueId),
  })
}
